/* eslint-disable max-classes-per-file */
import Container from 'quill/blots/container';
import QuillBlockquote from 'quill/formats/blockquote';
import type { Registry } from '../types';

export class BlockquoteContainer extends Container {}

class Blockquote extends QuillBlockquote {
  static register(registry: Registry) {
    registry.register(BlockquoteContainer);
  }
}

BlockquoteContainer.blotName = 'blockquote-container';
BlockquoteContainer.tagName = 'BLOCKQUOTE';
BlockquoteContainer.allowedChildren = [Blockquote];

Blockquote.requiredContainer = BlockquoteContainer;
Blockquote.tagName = 'DIV';
Blockquote.className = 'ql-blockquote-block';

export default Blockquote;
